import { getDefaultTimeZoneOnBrowser } from "./dates";

export const EMPTY_REVIEW = 'no content';
export const FLAT_RATE = 'flatRate';
export const PERCENTAGE_OF_RENTAL = 'percentageOfRental';
export const USAGE_MULTIPLE = 'usageMultiple';

export const FEE_TYPE_FIELD = 'feeType';
export const WHEN_TO_APPLY_FIELD = 'whenToApply';
export const FEE_CALC_TYPE_FIELD = 'feeCalculationType';
export const CHECKOUT_OPTIONS_FIELD = 'checkoutOptions';

export const REQUIRED_UPFRONT = 'requiredUpfront';
export const REQUIRED_UPFRONT_OPTIONAL = 'requiredUpfrontOptional';
export const DELIVERY_FEE = 'deliveryFee';
export const PICKUP_FEE = 'pickupFee';
export const SHIPPING_FEE = 'shippingFee';
export const CLEANING_FEE = 'cleaningFee';
export const SETUP_FEE = 'setupFee';
export const ENVIRONMENTAL_FEE = 'environmentalFee';
export const FUEL_FEE = 'fuelFee';
export const USAGE_FEE = 'usageFee';
export const ACCESSORY_FEE = 'accessoryFee';
export const CONSUMABLES_FEE = 'consumablesFee';


export const FEE_DESCRIPTION_FIELD = 'feeDescription';


export const ONLY_CHARGE_ONCE_FOR_ENTIRE_CART = 'oncePerCart';
export const CHARGE_FOR_THIS_ITEM_INDIVIDUALLY = 'oncePerItem';


export const FEE_TYPE_OPTIONS = [
  { value: DELIVERY_FEE, label: 'Delivery Fee' },
  { value: PICKUP_FEE, label: 'Pickup Fee' },
  { value: SHIPPING_FEE, label: 'Shipping Fee' },
  { value: CLEANING_FEE, label: 'Cleaning Fee' },
  { value: SETUP_FEE, label: 'Setup Fee' },
  { value: ENVIRONMENTAL_FEE, label: 'Environmental Fee' },
  { value: FUEL_FEE, label: 'Fuel Fee' },
];

export const WHEN_TO_APPLY_OPTIONS = [
  { value: REQUIRED_UPFRONT_OPTIONAL, label: 'Optional When Booking' },
  { value: REQUIRED_UPFRONT, label: 'Required When Booking' },
];

export const FEE_CALC_TYPE_OPTIONS = [
  { value: FLAT_RATE, label: 'Flat Fee' },
  { value: PERCENTAGE_OF_RENTAL, label: 'Percentage of Rental' },
  { value: USAGE_MULTIPLE, label: 'Usage Multiple' },
];

export const CHECKOUT_OPTIONS = [
  { value: ONLY_CHARGE_ONCE_FOR_ENTIRE_CART, label: 'Only charge once for the entire cart' },
  { value: CHARGE_FOR_THIS_ITEM_INDIVIDUALLY, label: 'Charge for this item individually' },
];


export const feeTypeMapper = {
  "deliveryFee": "Delivery Fee",
  "pickupFee": "Pickup Fee",
  "shippingFee": "Shipping Fee",
  "cleaningFee": "Cleaning Fee",
  "setupFee": "Setup Fee",
  "environmentalFee": "Environmental Fee",
  "fuelFee": "Fuel Fee",
  "usageFee": "Usage Fee",
  "accessoryFee": "Accessory Fee",
  "consumablesFee": "Consumables Fee",
};

export const urgencyFieldOptions = [
  { value: 'I need a reply ASAP', label: 'I need a reply ASAP' },
  { value: 'I can wait 24 hours', label: 'I can wait 24 hours' },
  { value: "I'm flexible", label: "I'm flexible" },
];

export const durations = [
  { value: 'flexible', label: 'Flexible' },
  { value: 'specific', label: 'Specific' }
];

export const FLEXIBLE_DURATION = 'flexible';
export const SPECIFIC_DURATION = 'specific';
export const durationTypes = [
  { value: 'Hours', label: 'Hours' },
  { value: 'Days', label: 'Days' },
]

export const FLEXIBLE_DATE = 'flexible';
export const SPECIFIC_DATE = 'specific'
export const dateOptions = [
  { value: "flexible", label: "Flexible" },
  { value: 'specific', label: 'Specific' }
]

export const deliverPickupOptions = [
  { label: 'Yes', value: 'yes' },
  { label: 'No, you will pickup', value: 'no, you will pickup' },
  { label: 'No applicable', value: 'no applicable' }
]
export const DELIVERY_YES = 'yes';
export const DELIVERY_NO = 'no, you will pickup';
export const DELIVERY_NOT_APPLICABLE = 'no applicable';

export const radiusOptions = [
  { label: "5 km", value: '5 km' },
  { label: "10 km", value: '10 km' },
  { label: "15 km", value: '15 km' },
  { label: "20 km", value: '20 km' },
  { label: "25 km", value: '25 km' }
]

export const budgetOptions = [
  { label: "Firm", value: 'firm' },
  { label: "Flexible", value: 'flexible' },
  { label: "Range", value: "range" }
];

export const BUDGET_FIRM_OPTION = 'firm';
export const BUDGET_FLEXIBLE_OPTION = 'flexible';
export const BUDGET_RANGE_OPTION = "range";

export const wayToConnectOptions = [
  { label: "Phone", value: 'phone' },
  { label: "Email", value: 'email' }
];

export const timeToConnectOptions = [
  { label: 'Select best time to connect', value: "" },
  { label: "8 AM - 12 PM", value: "8 AM - 12 PM" },
  { label: "12 PM - 4 PM", value: "12 PM - 4 PM" },
  { label: "4 PM - 8 PM", value: "4 PM - 8 PM" }
];

export const FIELD_ITEM_CONDITION = 'Condition_of_the_item';

export const PICKUP_AT_OWNER_LOCATION = 'Pickupat_owners_location';
export const facetLabelMappings = {
  category: {
    "Party-Event": "Party & Event",
    "Equipment-Tools": "Equipment & Tools",
    "Sports-Recreation": "Sports & Recreation",
    "Toys-Games-Music-Books-Art": "Toys, Games, Music, Books & Art",
    "Electronics-Furniture": "Electronics & Furniture",
    "photography-video": "Photography & Video",
    "Medical-Accessories": "Medical Accessories",
    "AnimalsAccessories": "Animal Accessories",
    "Kids-Baby": "Kids & Baby",
    "Miscellaneous": "Miscellaneous",
    "Moving": "Moving",
    "RV-Trailers": "RV & Trailers",
    "Fashion-Accessories": "Fashion Accessories",
    "Recreational-Vehicles": "Recreational Vehicles",
    "watercraft-accessories": "Watercraft Accessories",
    "Spaces-Storage": "Spaces & Storage",
    "People-Services": "People & Services",
  },
  security_deposit: {
    "50": "50",
    "100": "100",
    "250": "250",
    "500": "500",
    "no_deposit": "No Deposit",
  },
  access_to_rentals: {
    "Pickupat_owners_location": "Pickup at Owner's Location",
    "delivery_available": "Delivery Available",
    "public_meetup_location": "Public Meetup Location",
    "shipping": "Shipping",
    "service_where_required": "Service Where Required",
    "digitally": "Digitally",
  },
  cancelation_policy: {
    "flexible": "Flexible",
    "easy-going": "Easy Going",
    "strict": "Strict",
  },
  reason_for_listing: {
    "help_the_environment": "Help the Environment",
    "try_before-you_buy": "Try Before You Buy",
    "side_hustle": "Side Hustle",
    "in_the_rental_business": "In the Rental Business",
    "just_because": "Just Because",
  },
  Condition_of_the_item: {
    "Used_Like_New": "Used (Like New)",
    "Used_Good": "Used (Good)",
    "New": "New",
    "Used_Fair": "Used (Fair)",
    "its_a_service": "It's a Service",
  },
  Trust_and_verification: {
    "copy_of_drivers_licience": "Copy of Driver's License",
    "not_required": "Not Required",
    "2_social_media_site_links": "2 Social Media Site Links",
    "minimum_of_3_successful_rent": "Minimum of 3 Successful Rents",
  },
};

export const ACCESS_OPTIONS = {
  PICKUP: "Pickupat_owners_location",
  DELIVERY: "delivery_available",
  SHIP: "shipping",
  PUBLIC_MEETUP: 'public_meetup_location',
  SERVICE_REQUIRED: 'service_where_required',
  DIGITALLY: 'digitally',
}

export const DEFAULT_CURRENCY = 'USD';

export const LOCATIONINFO_COOKIE_KEY = 'userLocationInfo';
export const CURRENCY_COOKIE_KEY = 'userCurrency';

export const userPreservedStateKeys = ['currentUserLocationInfo', 'currentUserCurrency',];

export const UNREAD_MESSAGES_ROLE_ORDER = 'orders';
export const UNREAD_MESSAGES_ROLE_SALES = 'sales';

export const HOW_TO_USE_OPTION = 'howToUse';
export const LOCATIONS_OPTION = 'locations';
export const SUGGESTED_USES_OPTION = 'suggestedUses';
export const FAQS_OPTION = 'faqs';
export const LOCAL_RATES_OPTION = 'localRates';
export const ALT_TITLES_OPTION = 'altTitles';
export const REVIEW_SUMMARY_OPTION = 'reviewSummary';


export const ENHANCE_LISTING_OPTIONS = [
  {
    value: HOW_TO_USE_OPTION,
    icon: 'ri-lightbulb-flash-line',
    labelId: 'EnhanceListing.howToUse.title',
    descId: 'EnhanceListing.howToUse.desc',
    defaultSelected: true,
  },
  {
    value: LOCATIONS_OPTION,
    icon: 'ri-map-pin-line',
    labelId: 'EnhanceListing.locations.title',
    descId: 'EnhanceListing.locations.desc',
    defaultSelected: false,
  },
  {
    value: SUGGESTED_USES_OPTION,
    icon: 'ri-lightbulb-line',
    labelId: 'EnhanceListing.suggestedUses.title',
    descId: 'EnhanceListing.suggestedUses.desc',
    defaultSelected: true,
  },
  {
    value: FAQS_OPTION,
    icon: 'ri-question-answer-line',
    labelId: 'EnhanceListing.faqs.title',
    descId: 'EnhanceListing.faqs.desc',
    defaultSelected: true,
  },
  {
    value: LOCAL_RATES_OPTION,
    icon: 'ri-money-dollar-circle-line',
    labelId: 'EnhanceListing.localRates.title',
    descId: 'EnhanceListing.localRates.desc',
    defaultSelected: false,
  },
  {
    value: ALT_TITLES_OPTION,
    icon: 'ri-search-line',
    labelId: 'EnhanceListing.altTitles.title',
    descId: 'EnhanceListing.altTitles.desc',
    defaultSelected: true,
  },
  {
    value: REVIEW_SUMMARY_OPTION,
    icon: 'ri-star-smile-line',
    labelId: 'EnhanceListing.reviewSummary.title',
    descId: 'EnhanceListing.reviewSummary.desc',
    defaultSelected: true,
  },
];

export const REPLACEMENTVALUE_OPTIONS = [{ label: "$1-$250", option: "$1-$250" }, { label: "$251-$1000", option: "$251-$1000" }, { label: "$1001-$2500", option: "$1001-$2500" }, { label: "$2501-$5000", option: "$2501-$5000" }, { label: "$5000+", option: "$5000+" }];

export const CREATING_STEP_INPUT = 'input';
export const CREATING_STEP_PROCESSING = 'processing';
export const CREATING_STEP_PREVIEW = 'preview';

export const EDITING_STEP_DETAILS = 'details';
export const EDITING_STEP_PRICING = 'pricing';
export const EDITING_STEP_AVAILABILITY = 'availability';
export const EDITING_STEP_PHOTOS = 'photos';

export const LISTING_WIZARD_CREATING_ACTION = 'creating';
export const LISTING_WIZARD_EDITING_ACTION = 'editing';


export const PER_DAY = 'perDayPrice';
export const PER_MINUTE = 'perMinutePrice';
export const PER_HOUR = 'perHourPrice';
export const TWO_DAYS = 'twoDaysPrice';
export const WEEKLY_PRICE = 'oneWeekPrice';
export const OVERNIGHT_PRICE = 'overnightPrice';
export const TWENTY_EIGHT_DAYS = 'twentyEightDaysPrice';
export const DAY_PACKAGES = [PER_DAY, TWO_DAYS, WEEKLY_PRICE, OVERNIGHT_PRICE, TWENTY_EIGHT_DAYS];

export const ENABLED_VALUE = 'enabled';

export const aiListingFieldsOrder = [
  "title",
  "alternative_search_titles",
  "description",
  "instructions",
  "where_the_item_can_be_used",
  "suggested_usage_of_this_item",
  "category",
  "Condition_of_the_item",
  "replacement_value",
  "access_to_rentals",
  "Trust_and_verification",
  "security_deposit",
  "cancelation_policy",
  "reason_for_listing",
  "additionalFees",
  "faqs",
  "online_review_summary"
];

export const LISTING_DEFAULTS = {
  Condition_of_the_item: "Used_Fair",
  access_to_rentals: ["Pickupat_owners_location", "delivery_available"],
  Trust_and_verification: "copy_of_drivers_licience",
  cancelation_policy: "easy-going",
  security_deposit: "no_deposit",
  reason_for_listing: ["help_the_environment", "side_hustle"],
  quantity: 1,
};

export const DEFAULT_AVAILABILITY_PLAN = {
  type: "availability-plan/time",
  timezone: typeof window !== 'undefined' ? getDefaultTimeZoneOnBrowser() : 'Etc/UTC',
  entries: [
    {
      dayOfWeek: "sun",
      seats: 1000,
      startTime: "00:00",
      endTime: "00:00"
    },
    {
      dayOfWeek: "mon",
      seats: 1000,
      startTime: "00:00",
      endTime: "00:00"
    },
    {
      dayOfWeek: "tue",
      seats: 1000,
      startTime: "00:00",
      endTime: "00:00"
    },
    {
      dayOfWeek: "wed",
      seats: 1000,
      startTime: "00:00",
      endTime: "00:00"
    },
    {
      dayOfWeek: "thu",
      seats: 1000,
      startTime: "00:00",
      endTime: "00:00"
    },
    {
      dayOfWeek: "fri",
      seats: 1000,
      startTime: "00:00",
      endTime: "00:00"
    },
    {
      dayOfWeek: "sat",
      seats: 1000,
      startTime: "00:00",
      endTime: "00:00"
    }
  ]
};

export const AVAILABILITY_FIELD_24_7 = 'available247';

export const LISTING_ALOGLIA_REMOVABLE_FIELDS = [
  'order',
  'instructions',
  'faqs',
  'additionalFees',
  'where_the_item_can_be_used',
  'suggested_usage_of_this_item',
  'online_review_summary',
  'generatedImages',
  'faqsEnabled',
  'alternative_search_titlesEnabled',
  'instructionsEnabled',
  'suggested_usage_of_this_itemEnabled',
  'where_the_item_can_be_usedEnabled',
];

export const LISTING_USER_PUBLIC_DATA_REMOVABLE_FIELDS = [
  'cart',
  'acceptedTransactions',
  'seoTitle',
  'seoDescription',
];
  